import React from 'react'
import TokenChart from '../TokenChart'

const ChartSection = ({ address, backgroundColor, price }) => {
  return (
    <div
      style={{
        background: '#1b1c21',
        borderRadius: '16px',
        padding: '20px',
        minWidth: '0',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '481px',
        boxSizing: 'border-box',
        overflow: 'visible',
      }}
    >
      <TokenChart address={address} color={backgroundColor} base={price} />
    </div>
  )
}

export default ChartSection
